// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import highways from '../constants/highways'
import {inRange} from 'lodash'
import {message} from 'antd'
import { LnglatShift } from './lnglat-shift'

export const getRoadTypes = zoom => {
  if (zoom < 14) {
    return highways.slice(0, 2)
  }
  if (zoom < 15) {
    return highways.slice(0, 4)
  }
  if (zoom < 16) {
    return highways.slice(0, 6)
  }
  if (zoom < 17) {
    return highways.slice(0, 8)
  }
  return highways
}
export const validateGeoPoints = point => {
  const [longitude, latitude] =point
  if (!inRange(longitude,-180, 180)) {
    message.info('longitude must be in [-180,180]')
    return false
  }
  if(!inRange(latitude, -90,90)){
    message.info('latitude must be in [-90,90]')
    return false
  }
  return true
}
